// VERA assistant voice options (ElevenLabs). Voice IDs are public identifiers,
// not secrets. Verify/swap them in your ElevenLabs dashboard as needed.

export interface AssistantVoice {
  key: string;
  label: string;
  voiceId: string;
  description: string;
}

// VERA is female — two female voices, no gender labels.
// voiceId values are ElevenLabs voice IDs (public identifiers, not secrets);
// swap them for your own custom VERA voices from the ElevenLabs dashboard.
export const ASSISTANT_VOICES: AssistantVoice[] = [
  { key: 'vera01', label: 'VERA 01', voiceId: 'qLqFzuQGrRXyVRaqbLOt', description: 'Calm, professional' },
  { key: 'vera02', label: 'VERA 02', voiceId: '1nqVMzWTc86S5xB4Yfg9', description: 'Warm, soft' },
];

export const DEFAULT_VOICE_KEY = 'vera01';

export const getVoice = (key: string | undefined): AssistantVoice =>
  ASSISTANT_VOICES.find((v) => v.key === key) || ASSISTANT_VOICES[0];

export const VOICE_PREVIEW_TEXT =
  "Hi, I'm VERA. I can help you get around the app and word your notes.";
